import React from 'react';
import { motion } from 'framer-motion';
import { HiSparkles, HiBadgeCheck, HiHand, HiHeart, HiShieldCheck, HiCurrencyRupee, HiExternalLink } from 'react-icons/hi';

const features = [
  { icon: HiBadgeCheck, title: 'Pure & Authentic', description: '100% genuine Ilkal sarees — no imitations, no shortcuts. Authenticity you can feel in every thread.' },
  { icon: HiHand, title: 'Handpicked by Me', description: 'Every single saree is personally handpicked — curated with care so only the finest reaches you.' },
  { icon: HiSparkles, title: 'Elegant & Timeless', description: 'Classic Ilkal weaves and motifs that carry tradition with effortless, head-turning elegance.' },
  { icon: HiShieldCheck, title: 'Safe & Secure Delivery', description: 'Carefully packed and delivered so its beauty reaches your hands completely undisturbed.' },
  { icon: HiHeart, title: 'Crafted with Love', description: 'Supporting traditional weavers — heritage craftsmanship that deserves a place in your wardrobe.' },
  { icon: HiCurrencyRupee, title: 'Best Prices', description: 'Premium, pure Ilkal sarees at honest, best-in-market prices — luxury without the markup.' },
];

const IlkalKart = () => {
  return (
    <section id="ilkalkart" className="relative overflow-hidden" style={{ background: '#fdf6f0' }}>
      <div className="absolute inset-0 line-grid pointer-events-none" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32">
        {/* Top bar */}
        <div className="flex items-center gap-4 mb-6">
          <div className="w-2.5 h-2.5 rounded-full" style={{ background: '#9d2235', boxShadow: '0 0 0 4px rgba(157,34,53,0.15)' }} />
          <span className="mono-label" style={{ color: '#9d2235' }}>Just Launched</span>
          <span className="mono-label" style={{ color: '#b08968' }}>·</span>
          <span className="mono-label" style={{ color: '#b08968' }}>ilkalkart.in</span>
        </div>

        {/* Massive headline */}
        <div className="grid lg:grid-cols-[1.5fr_1fr] gap-16 items-start mb-20">
          <div>
            <h2 className="text-display mb-8" style={{ color: '#1a1a1a' }}>
              IlkalKart.
              <br />
              <span style={{ color: '#9d2235' }}>Drape the heritage.</span>
            </h2>
            <div className="brutalist-line mb-6" />
            <p className="text-[17px] leading-[1.7] font-medium max-w-lg" style={{ color: '#5c4a42' }}>
              <strong style={{ color: '#1a1a1a' }}>ilkalkart.in</strong> is live — your destination for
              <strong style={{ color: '#9d2235' }}> pure, authentic and genuine</strong> Ilkal sarees at the
              best prices. Every drape is <em>handpicked completely by me</em> — elegant weaves delivered
              the safe, secure way, so their beauty reaches your hands untouched and undisturbed.
            </p>
          </div>

          {/* CTA column */}
          <div className="flex flex-col gap-4 lg:pt-8">
            <a href="https://ilkalkart.in" target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-3 justify-center font-bold uppercase tracking-[0.06em] text-[13px] py-4 px-6"
              style={{ background: '#9d2235', color: '#ffffff' }}>
              Visit ilkalkart.in <HiExternalLink className="w-4 h-4" />
            </a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="inline-flex items-center justify-center gap-3 font-bold uppercase tracking-[0.06em] text-[13px] py-4 px-6"
              style={{ border: '1.5px solid #1a1a1a', color: '#1a1a1a' }}>
              Build something similar
            </a>
            <div className="flex items-center gap-3 mt-4 px-1">
              <div className="w-8 h-8 flex items-center justify-center" style={{ background: '#9d2235' }}>
                <HiBadgeCheck className="w-5 h-5" style={{ color: '#ffffff' }} />
              </div>
              <div>
                <p className="text-[12px] font-bold" style={{ color: '#1a1a1a' }}>Personally Curated Collection</p>
                <p className="text-[10px] font-medium" style={{ color: '#8a7268' }}>Handpicked, verified pure — directly from the loom to you</p>
              </div>
            </div>
          </div>
        </div>

        {/* Features — horizontal strip layout */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-0" style={{ borderTop: '1px solid #e7d9cd' }}>
          {features.map((item, idx) => {
            const Icon = item.icon;
            return (
              <motion.div key={item.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.1, duration: 0.5 }}
                className="py-10 px-8 group cursor-default"
                style={{
                  borderRight: (idx % 3 !== 2) ? '1px solid #e7d9cd' : 'none',
                  borderBottom: idx < 3 ? '1px solid #e7d9cd' : 'none',
                }}>
                <div className="flex items-center gap-3 mb-5">
                  <Icon className="w-5 h-5" style={{ color: '#9d2235' }} />
                  <span className="text-[11px] font-bold uppercase tracking-[0.06em]" style={{ color: '#1a1a1a' }}>
                    {item.title}
                  </span>
                </div>
                <p className="text-[13px] leading-[1.7] font-medium" style={{ color: '#5c4a42' }}>
                  {item.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default IlkalKart;
